import React from 'react'

const Blog = () => {
  return (
    <div className="h-screen flex justify-center items-center">
      <h1 className="text-lime-400 text-3xl">Comming soon...</h1>
    </div>
  )
}

export default Blog
